<template>
  <div id="app">
    <DeepifyHeader />
    <div class="main">
      <router-view />
    </div>
    <vue-snotify />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DeepifyHeader from '@/components/core/Header.vue';

export default {
  name: 'App',
  components: {
    DeepifyHeader,
  },
  computed: {
    ...mapGetters([
      'token',
    ]),
  },
  created() {
    this.fetchToken();
  },
  methods: {
    ...mapActions([
      'fetchToken',
    ]),
  },
};
</script>
<style>
[role="main"] {
  padding-top: 108px; /* Space for fixed navbar */
}

@media (min-width: 576px) {
  [role="main"] {
    padding-top: 56px;
    padding-left: 0!important;
    padding-right: 0!important;
  }
}

body div {
    font-family: 'Montserrat';
}

body .border-2 {
  border-width: 2px!important;
}

.main {
  padding: 56px 0 0!important;
}

.top-0 {
  top: 0;
}

.bottom-0 {
  bottom: 0;
}

.left-0 {
  left: 0;
}

.right-0 {
  right: 0;
}

.rounded-2 {
  border-radius: 20px;
}

.rounded-top-2 {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

.rounded-bottom-2 {
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

.cursor-pointer {
    cursor: pointer;
}

.deepify-dark-bg {
    background: #444444;
    color: #f1f1f1;
}

.deepify-gray-bg {
  background: #525252;
}

.deepify-dark-text {
    color: #444444;
}

.deepify-gray-text {
  color: #525252;
}

.deepify-light-bg {
    background: #f1f1f1;
    color: #444444;
}

.deepify-light-text {
    color: #f1f1f1;
}

.deepify-bg-success {
    background: #2aea77;
    color: #444444;
}

.deepify-text-success {
  color: #2aea77;
}
</style>
